import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types";
import { colors, resolveColor, font } from "utils/styles";
import renderItem from "utils/renderItem";
import Title from "./Title";
import ImageCard from "./ImageCard";
import ArticleInclude from "./ArticleInclude";
import DynamicLink from "./DynamicLink";

import getKey from "utils/getKey";

export default function GeneralRichText(props) {
	let content = props.content;
	let fields;

	if (content?.fields) {
		fields = props.content.fields;
		content = fields.text;
	} else if (content?.json?.content) {
		content = content?.json;
	}
	const contentBackgroundColor = fields?.contentBackgroundColor;

	const hashLink = fields?.hashLink;
	const contentClasses = fields?.contentClasses ? fields?.contentClasses : props.className ? props.className : " ";
	const maxWidth = fields?.maxWidth ? `${fields.maxWidth}px` : "100%";
	const colorLine = props.colorLine ? props.colorLine : fields?.colorLine ? resolveColor(fields?.colorLine) : null;
	const lineSide = props.colorLineSide ? props.colorLineSide : fields?.colorLineSide;
	const thickness = props.colorLineThickness ? props.colorLineThickness : fields?.colorLineThickness;
	const colorLinePadding = props.colorLinePadding ? props.colorLinePadding : fields?.colorLinePadding;
	const align = fields?.textAlign;
	const textClass = fields?.class || "";

	// return "ok";

	return (
		<div
			className={`${contentClasses} maxWidth GeneralRichTextComponent`}
			id={hashLink}
			style={{
				//conditionally add border for style
				...(colorLine && {
					[`border${lineSide}`]: `${thickness}px solid ${colorLine}`,
					...(colorLinePadding && {
						[`padding${lineSide}`]: `${colorLinePadding}em`,
					}),
				}),
				textAlign: align,
			}}
		>
			{content &&
				documentToReactComponents(content, {
					renderText: (text) => {
						text = searchCharCodes(text);
						return text.split("\n").reduce((acc, curr, i) => {
							if (i === 0) return [curr];
							return [...acc, <br key={`br-${i}-${getKey()}`} />, curr];
						}, []);
					},

					renderNode: {
						[BLOCKS.HEADING_1]: (node, children) => {
							return (
								<h1 className={textClass} key={getKey()}>
									{children}
								</h1>
							);
						},
						[BLOCKS.HEADING_2]: (node, children) => {
							return (
								<h2 className={textClass} key={getKey()}>
									{children}
								</h2>
							);
						},
						[BLOCKS.HEADING_3]: (node, children) => {
							return (
								<h3 className={textClass} key={getKey()}>
									{children}
								</h3>
							);
						},

						[BLOCKS.HEADING_4]: (node, children) => {
							return (
								<h4 className={textClass} key={getKey()}>
									{children}
								</h4>
							);
						},
						[BLOCKS.HEADING_5]: (node, children) => {
							return (
								<h5 className={textClass} key={getKey()}>
									{children}
								</h5>
							);
						},
						[BLOCKS.HEADING_6]: (node, children) => {
							return (
								<h6 className={textClass} key={getKey()}>
									{children}
								</h6>
							);
						},
						[BLOCKS.PARAGRAPH]: (node, children) => {
							return (
								<p className={textClass} key={getKey()}>
									{children}
								</p>
							);
						},
						[BLOCKS.QUOTE]: (node, children) => {
							return (
								<blockquote className="blockquote" key={getKey()}>
									{children}
								</blockquote>
							);
						},

						[BLOCKS.TABLE]: (node, children) => {
							return (
								// <table>
								<div>{children}</div>
								// </table>
							);
						},
						[BLOCKS.TABLE_ROW]: (node, children) => {
							return (
								<>
									<div className="row">{children}</div>
									<hr />
								</>
							);
						},
						[BLOCKS.TABLE_CELL]: (node, children) => <div className="col">{children}</div>,

						[BLOCKS.EMBEDDED_ASSET]: (node, children) => {
							return (
								<img
									key={getKey()}
									// className={`${node?.data?.target?.fields ? node?.data?.target?.fields : " "} w-100`}
									className={`w-100`}
									src={node?.data?.target?.fields?.file?.url}
									alt={node?.data?.target?.fields?.description}
								/>
							);
						},

						[BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
							if (!node?.data?.target) {
								//some kind of contentful richtext editor bug giving empty embedded element blocks
								return <></>;
							}
							const type = node.data.target.sys.contentType.sys.id;
							if (type === "media") {
								return <ImageCard key={getKey()} data={node?.data?.target} />;
							} else if (type === "title") {
								return <Title key={getKey()} title={node?.data?.target} />;
							} else if (type === "content") {
								// return <Content content={node?.data?.target} />;
								return <GeneralRichText key={getKey()} content={node.data.target.fields.text} />;
							} else if (type === "articleInclude" || type === "table" || type === "cta") {
								return <ArticleInclude key={getKey()} data={node?.data?.target} />;
							} else {
								return <span>{renderItem(node.data.target)}</span>;
							}
						},
						[BLOCKS.LIST_ITEM]: (node, children) => {
							return <li>{children}</li>;
						},

						[INLINES.HYPERLINK]: (node, children) => {
							return (
								<DynamicLink classes={"link d-inline"} href={node.data.uri}>
									{children}
								</DynamicLink>
							);
						},

						[INLINES.EMBEDDED_ENTRY]: (node, children) => {
							if (!node?.data?.target) {
								//some kind of contentful richtext editor bug giving empty embedded element blocks
								return <></>;
							}
							const type = node.data.target.sys.contentType.sys.id;

							if (type === "media") {
								return <ImageCard key={getKey()} data={node?.data?.target} />;
							} else if (type === "title") {
								return <Title title={node?.data?.target} />;
							} else if (type === "content") {
								const nestedContentClass = node.data.target.fields?.nestedContentClass || "";

								return (
									<span className={nestedContentClass}>
										{/* <GeneralRichText content={node.data.target.fields.text} /> */}
										<GeneralRichText content={node.data.target} />
									</span>
								);
							} else {
								return <span>{renderItem(node.data.target)}</span>;
							}
						},
					},
					renderMark: {
						[MARKS.BOLD]: (text) => {
							return (
								<b className="boldColor" key={getKey()}>
									{text}
								</b>
							);
						},
					},
				})}

			<style jsx>{`
				.GeneralRichTextComponent {
					background: ${resolveColor(contentBackgroundColor)};
				}
				.maxWidth {
					max-width: ${maxWidth};
				}
				b {
					color: ${fields?.boldTextColor ? resolveColor(fields?.boldTextColor) : "inherit"};
				}
				a {
					color: ${colors.green} !important;
					text-decoration: underline;
				}

				h1 {
					font-family: "Athelas";
					color: ${colors.darkBlue};
				}

				@media screen and (max-width: 768px) {
					h1 {
						font-size: 36px;
						line-height: 40px;
					}
				}

				@media screen and (min-width: 768px) {
					h1 {
						font-size: 40px;
						line-height: 40px;
					}
				}

				@media screen and (min-width: 992px) {
					h1 {
						font-size: 46px;
						line-height: 50px;
					}
				}

				@media screen and (min-width: 1400px) {
					h1 {
						font-size: 56px;
						line-height: 60px;
					}
				}

				h2 {
					margin: 0;
					margin-bottom: 20px;
					color: ${colors.darkBlue};
					font-size: 36px;
					line-height: 42px;
					font-family: ${font.Athelas};
				}

				@media screen and (max-width: 991px) {
					h2 {
						font-size: 30px;
						line-height: 38px;
					}
				}

				h3 {
					margin: 0;
					margin-bottom: 15px;

					color: ${colors.darkBlue};

					font-family: ${font.Athelas};
				}

				h4 {
					margin: 10px 0px;

					font-family: "Open Sans";
					color: ${colors.dark};
				}

				h5 {
					color: ${colors.dark};

					font-family: "Open Sans";
				}

				h6 {
					/* font-size: 17px; */
					font-family: "Open Sans";
					color: ${colors.dark};
				}

				p {
					font-size: 17px;
					line-height: 28px;
					font-family: "Open Sans";
					color: ${colors.lightBrown};
				}

				@media screen and (max-width: 991px) {
					p {
						font-size: 16px;
						line-height: 26px;
					}
				}

				blockquote {
					border-left: 10px solid ${colors.red}; /* Grey left border */
					margin: 1em 10px; /* Some margin around the block quote */
					padding: 0.5em 10px; /* Padding inside the block quote */
					font-style: italic; /* Italic text style */
					font-family: "Athelas";
					font-size: 30px;
				}

				blockquote p {
					display: inline; /* Ensures inline display of paragraphs inside blockquote */
					font-style: italic; /* Italic text style */
					font-size: 40px;
				}

				blockquote footer {
					text-align: right; /* Aligns the footer text to the right */
					font-size: 0.9em; /* Slightly smaller font size */
					color: #666; /* Medium grey text color */
					margin-top: 0.5em; /* Space above the footer text */
				}

				blockquote::before {
					content: open-quote; /* CSS way to insert left double quote */
					font-size: 4em; /* Large font size for the quote symbol */
					line-height: 0.1em; /* Adjusts the line height */
					margin-right: 0.25em; /* Space between quote symbol and text */
					vertical-align: -0.4em; /* Vertically align the quote symbol */
					color: ${colors.yellow}; /* Light grey color for the quote symbol */
				}

				blockquote::after {
					content: close-quote; /* CSS way to insert right double quote */
					font-size: 4em; /* Large font size for the quote symbol */
					line-height: 0.1em; /* Adjusts the line height */
					margin-left: 0.25em; /* Space between quote symbol and text */
					vertical-align: -0.4em; /* Vertically align the quote symbol */
					color: ${colors.yellow}; /* Light grey color for the quote symbol */
				}
			`}</style>
		</div>
	);
}

function searchCharCodes(str, isTitle) {
	const len = str.length;

	// const trailingHyphen = str.charAt(str.length - 1) === "-";
	// if (trailingHyphen) {

	// }

	// if (str.includes("  ")) {

	// 	str = str.replaceAll("  ", " ");
	// }

	// return;
	for (let x = 0; x < len; x++) {
		const code = str.charCodeAt(x);
		// code === 8217 ||
		// code === 173
		if (code === 173) {
			// ""
			str = str.replaceAll(str.charAt(x), "");
			return searchCharCodes(str, isTitle);
		}
		if (code === 8232) {
			str = str.replaceAll(str.charAt(x), "");
			return searchCharCodes(str, isTitle);
		}
		// if (code === 8217) {

		// 	//"’"
		// 	const replaceWith = isTitle ? `'` : "";
		// 	str = str.replaceAll(str.charAt(x), replaceWith);
		// 	return searchCharCodes(str, isTitle);
		// }
		// if (code === 8212) {

		// 	//"—"
		// 	str = str.replaceAll(str.charAt(x), "-");
		// 	return searchCharCodes(str, isTitle);
		// }
		// if (code === 8220) {

		// 	//"“"
		// 	const replaceWith = isTitle ? `"` : "";

		// 	str = str.replaceAll(str.charAt(x), replaceWith);
		// 	return searchCharCodes(str, isTitle);
		// }
		// if (code === 8221) {

		// 	//"”"
		// 	const replaceWith = isTitle ? `"` : "";

		// 	str = str.replaceAll(str.charAt(x), replaceWith);
		// 	return searchCharCodes(str, isTitle);
		// }
		// if (code === 8216) {

		// 	//"‘"
		// 	const replaceWith = isTitle ? `'` : "";

		// 	str = str.replaceAll(str.charAt(x), replaceWith);
		// 	return searchCharCodes(str, isTitle);
		// }
		// if (code === 8211) {

		// 	//"–"
		// 	str = str.replaceAll(str.charAt(x), "-");
		// 	return searchCharCodes(str, isTitle);
		// }
		// if (code === 160) {

		// 	// example sting with bad space " "
		// 	// ("The Phone in the Healthcare Practice: Ongoing Training and Development");
		// 	// " "
		// 	str = str.replaceAll(str.charAt(x), " ");
		// 	return searchCharCodes(str, isTitle);
		// }

		if (code < 32 || code > 126) {
			// str = str.replaceAll(str.charAt(x), "");
			// return searchCharCodes(str, isTitle);
		}
	}

	return str;
}
